import React, { useEffect, useState } from "react";
import { TextField, Button, CircularProgress, Box } from "@mui/material";
import { rchAPI } from "../../services/rch.api";
import { toast } from "react-toastify";
import "./Rch.css";

const RCHRegistrationPreview = ({ onClose, rchBeneficiaryData }) => {
    const [loading, setLoading] = useState(true);
    const [beneficiary, setBeneficiary] = useState(null);

    useEffect(() => {
        const loggedinUserdetails = JSON.parse(localStorage.getItem("JANANI_loggedinUserdetails")) || {};

        const fetchDetails = async () => {
            if (!rchBeneficiaryData?.benef_id || !rchBeneficiaryData?.mobile) {
                setLoading(false);
                return;
            }

            try {
                const response = await rchAPI.viewRchBeneficiaryData({
                    benfId: rchBeneficiaryData?.benef_id,
                    // mobileNumber: rchBeneficiaryData.mobile
                    mobileNumber: loggedinUserdetails?.mobile
                });

                if (response?.success) {
                    setBeneficiary(response?.data?.data?.beneficiary);
                } else {
                    const errorMessage = response?.messages?.[0]?.messageDetails || response?.message || "Failed to fetch beneficiary details";
                    toast.error(errorMessage);
                }
            } catch (error) {
                const errorMessage = error?.response?.data?.messages?.[0]?.messageDetails || "Error fetching beneficiary details";
                toast.error(errorMessage);
            } finally {
                setLoading(false);
            }
        };

        fetchDetails();
    }, [rchBeneficiaryData]);

    return (
        <section className="rch-registration-section bg-white rounded shadow-sm p-4 mt-3 position-relative">
            <div className="leftHeaderBar">
                <h4>
                    <span>
                        <img
                            src={"/images/Rchicon.svg"}
                            alt=""
                            style={{ width: "50px", marginRight: "15px" }}
                        />
                    </span>
                    JANANI Beneficiary Preview
                </h4>
            </div>

            {loading ? (
                <Box display="flex" justifyContent="center" alignItems="center" p={5}>
                    <CircularProgress size={40} />
                </Box>
            ) : !beneficiary ? (
                <p className="text-center text-muted p-4">No beneficiary details found.</p>
            ) : (
                <>
                    <div className="row g-3">
                        {/* ABHA Number */}
                        <div className="col-md-4">
                            <label className="form-label">ABHA Number</label>
                            <TextField
                                fullWidth
                                value={beneficiary?.abha_id || "N/A"}
                                variant="outlined"
                                size="small"
                                InputProps={{ readOnly: true }}
                            />
                        </div>

                        {/* Beneficiary Name */}
                        <div className="col-md-4">
                            <label className="form-label">Beneficiary Name</label>
                            <TextField
                                fullWidth
                                value={beneficiary?.benf_name || "N/A"}
                                variant="outlined"
                                size="small"
                                InputProps={{ readOnly: true }}
                            />
                        </div>

                        {/* Gender */}
                        <div className="col-md-4">
                            <label className="form-label">Gender</label>
                            <TextField
                                fullWidth
                                value={beneficiary?.gender_name || "N/A"}
                                variant="outlined"
                                size="small"
                                InputProps={{ readOnly: true }}
                            />
                        </div>

                        {/* DOB */}
                        <div className="col-md-4">
                            <label className="form-label">Beneficiary DOB</label>
                            <TextField
                                fullWidth
                                value={beneficiary?.dob ? new Date(beneficiary?.dob).toLocaleDateString() : "N/A"}
                                variant="outlined"
                                size="small"
                                InputProps={{ readOnly: true }}
                            />
                        </div>

                        {/* Primary Phone */}
                        <div className="col-md-4">
                            <label className="form-label">Primary Phone Number</label>
                            <TextField
                                fullWidth
                                value={beneficiary?.mob || "N/A"}
                                variant="outlined"
                                size="small"
                                InputProps={{ readOnly: true }}
                            />
                        </div>
                    </div>

                    <div className="d-flex justify-content-end gap-3 mt-4">
                        <Button
                            variant="contained"
                            className="btn-info text-white rounded-pill px-4"
                            style={{ background: "#0dcaf0", border: "none" }}
                            onClick={onClose}
                        >
                            Close
                        </Button>
                    </div>
                </>
            )}

            <div className="closeDive nikshayclose" onClick={onClose}>
                <img src="/images/closing.svg" alt="Close" />
            </div>
        </section>
    );
};

export default RCHRegistrationPreview;